import type { AppState } from 'state/state.model';

export * from './product.selector.bcs';
export * from './product.selector.domino';

const select = (appState: AppState, tabId: string) =>
  appState.secondaryMarket.cpOrder.referential.product[tabId]?.quantityInfo;
export const getCpOrderReferentialMaxQuantityBuy = (appState: AppState, tabId: string) =>
  select(appState, tabId)?.sgMaxBuy;
export const getCpOrderReferentialMaxQuantitySell = (appState: AppState, tabId: string) =>
  select(appState, tabId)?.sgMaxSell;
export const getCpOrderReferentialMinQuantity = (appState: AppState, tabId: string) => select(appState, tabId)?.sgMin;
export const getCpOrderReferentialLotSize = (appState: AppState, tabId: string) => select(appState, tabId)?.lotSize;
export const getCpOrderReferentialRemaining = (appState: AppState, tabId: string) => select(appState, tabId)?.remaining;
